import React from "react"

const InputCount = ({ label, onChange, value, max }) => {
  return (
    <fieldset>
      <label className="text-gray-700 capitalize" htmlFor="">
        {label}
      </label>

      <div className="flex justify-between items-center px-4">
        <div
          className="cursor-pointer hover:text-gray-700"
          onClick={() => value > 1 && onChange(--value)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              // stroke="#4A5568"
              className="stroke-current"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <div>
          <p>{value}</p>
        </div>
        <div
          className="cursor-pointer hover:text-gray-700"
          onClick={() => max > value && onChange(++value)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              className="stroke-current"
              // stroke="#4A5568"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>
    </fieldset>
  )
}

export default InputCount
